const callback = function(entries) {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('is-visible');
      // Unobserve so adding .is-visible is only fired once
      observer.unobserve(entry.target);
    } else {
      // Callback is fired on page load, Need to remove .is-visible
      entry.target.classList.remove('is-visible');
    }
  });
};

const observer = new IntersectionObserver(callback);

const targets = document.querySelectorAll(".show-on-scroll");
targets.forEach(function(target) {
  observer.observe(target);
});
